import React, { Component } from 'react';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styles, T as TabsHeader } from '../TabsHeader-86b77160.js';
import '../style-inject.es-746bb8ed.js';

class Tab extends Component {
  constructor(props) {
    super(props);
    this.render = () => this.props.selected && /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "tabpanel",
        key: this.props.value,
        "aria-labelledby": `${this.props.value}_header`,
        id: `${this.props.value}_panel`
      },
      this.props.children
    );
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
}
class Tabs extends Component {
  constructor(props) {
    super(props);
    this.componentWillReceiveProps = (nextProps) => {
      if (nextProps.value !== this.state.activeTab) {
        this.setState({ activeTab: nextProps.value });
      }
    };
    this.getTabHeaders = (tabs) => React.Children.map(tabs, (tab) => ({
      label: tab.props.label,
      value: tab.props.value
    }));
    this.renderTabs = () => React.Children.map(
      this.props.children,
      (tab) => (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        React.cloneElement(tab, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          selected: this.state.activeTab === tab.props.value
        })
      )
    );
    this.onKeyDown = (event, currentIndex) => {
      var _a;
      const index = this.state.focusIndex === -1 ? 0 : this.state.focusIndex;
      const headersLength = (_a = this.props.children) == null ? void 0 : _a.length;
      let nextIndex = -1;
      switch (event.key) {
        case "ArrowLeft":
        case "ArrowUp":
          nextIndex = index === 0 ? headersLength - 1 : index - 1;
          break;
        case "ArrowRight":
        case "ArrowDown":
          nextIndex = (index + 1) % headersLength;
          break;
        case "Tab":
          this.setState({ focusIndex: currentIndex });
          break;
        case " ":
        case "Enter":
          event.target.click();
          break;
      }
      if (nextIndex > -1) {
        this.setState({ focusIndex: nextIndex });
      }
    };
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.state = { activeTab: props.value, focusIndex: -1 };
  }
  render() {
    var _a;
    const { styles: styles2, props } = this;
    const headers = this.getTabHeaders(props.children);
    return /* @__PURE__ */ React.createElement("div", { role: "tablist", className: styles2.tabs, "aria-orientation": "horizontal" }, /* @__PURE__ */ React.createElement("div", { className: classNames(styles2.tabs_headers, (_a = this.props) == null ? void 0 : _a.headersStyle) }, headers.map(({ label, value }, i) => {
      const isSelected = value === this.state.activeTab;
      return /* @__PURE__ */ React.createElement(
        TabsHeader,
        {
          key: label,
          label,
          value,
          focused: i === this.state.focusIndex,
          isSelected,
          onKeyDown: (e) => this.onKeyDown(e, i),
          focusIndex: this.state.focusIndex,
          onClick: () => {
            this.setState({ activeTab: value });
            if (this.props.onTabSelected) {
              this.props.onTabSelected(value);
            }
            this.renderTabs();
          }
        }
      );
    })), this.renderTabs());
  }
}

export { Tab, Tabs };
//# sourceMappingURL=Tabs.js.map
